import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { unescape } from 'lodash';
import FontFamily from './font-family/FontFamily';
import FontSize from './font-size/FontSize';
import FontColor from './font-color/FontColor';
import StrokeColor from './stroke-color/strokeColor';
import DeleteBtn from './delete-btn/DeleteBtn';
import TextInput from './text-input/TextInput';
import { postTextData } from './../../redux/helpers/texts';
import './TextTools.css';


class TextTools extends Component {
  constructor(...args) {
    super(...args);
    this.state = ({
      collapsed: false,
    });
  }

  componentDidUpdate(prevProps) {
    const {
      texts,
      bookProperties,
    } = this.props;
    const { context } = bookProperties;
    const { texts: prevTexts } = prevProps;
    const activeTextField = Object.values(texts).find(element => element.isActive);
    const prevTextField = Object.values(prevTexts).find(element => element.isActive);

    if (activeTextField && activeTextField.images && prevTextField) {
      const { ratio } = bookProperties.bookSizes;
      const { photoBookId } = bookProperties;

      const data = {
        id: activeTextField.id,
        text: unescape(activeTextField.text),
        fontSize: activeTextField.fontSize,
        font: activeTextField.font,
        color: activeTextField.color,
        shadow: false,
        stroke: activeTextField.stroke,
        strokeColor: activeTextField.strokeColor,
        ratio,
        bookId: photoBookId,
        isSpine: activeTextField.isSpineText,
        context,
        isBabyText: activeTextField.isBabyText,
      };

      if (activeTextField.text === '') {
        return null;
      }
      if (
        prevTextField.color !== activeTextField.color ||
        prevTextField.fontSize !== activeTextField.fontSize ||
        prevTextField.font !== activeTextField.font ||
        prevTextField.stroke !== activeTextField.stroke ||
        prevTextField.strokeColor !== activeTextField.strokeColor ||
        unescape(prevTextField.text) !== unescape(activeTextField.text)
      ) {
        postTextData(data, this.props.dispatch);
      }
    }
  }

  handleCollapse = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    const {
      lang,
      texts,
    } = this.props;

    const isSpineText = Object.values(texts).some(element => element.isSpineText && element.isActive);
    const activeTextField = Object.values(texts).find(element => element.isActive);
    if (!activeTextField) {
      return null;
    }

    const {
      isEditable,
      disableTools,
    } = activeTextField;

    if (disableTools !== undefined && disableTools) {
      return <div />;
    }

    const TextIsEditable = isEditable || isEditable === undefined;


    return (

      <div className={`toolbarContainer ${activeTextField ? 'active' : ''}`}>
        <div className="col text">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 15 16"
            enableBackground="new 0 0 15 16"
            xmlSpace="preserve"
          >
            <path d="M6.5,3.7L8.6,9H4.4L6.5,3.7z M7,0L1,15H0v1h3v-1H2l2-5h5l2,5h-1v1h5v-1h-1L8,0H7z" />
          </svg>
          <h2>{lang.insert_text}</h2>
          <button onClick={this.handleCollapse} className="collapse-btn">
            <i className={`fa ${!this.state.collapsed ? 'fa-chevron-down' : 'fa-chevron-up'}  `} />
          </button>
        </div>
        <div className={`collapse-body ${this.state.collapsed ? 'collapse' : ''} `}>

          { (TextIsEditable) &&
            <div className="col">
              <FontFamily
                textFieldId={activeTextField.id}
                font={activeTextField.font}
              />
            </div>
          }

          { (TextIsEditable) && !isSpineText &&
            <div className="col">
              <FontSize
                textFieldId={activeTextField.id}
                fontSize={activeTextField.fontSize}
              />
            </div>
          }

          { (TextIsEditable) && <FontColor
            textFieldId={activeTextField.id}
            color={activeTextField.color}
          />
          }

          {(TextIsEditable) && !isSpineText &&
            <StrokeColor
              textFieldId={activeTextField.id}
              hasStroke={activeTextField.stroke}
              strokeColor={activeTextField.strokeColor}
            />
          }

          <TextInput
            textFieldId={activeTextField.id}
            text={unescape(activeTextField.text)}
            isOverflow={activeTextField.isOverflow}
            isBabyText={activeTextField.isBabyText}
            lang={lang}
          />
          {(TextIsEditable) &&
            <DeleteBtn
              textFieldId={activeTextField.id}
            />
          }
        </div>
      </div>
    );
  }
}

TextTools.defaultProps = {
  lang: {},
  texts: {},
  bookProperties: {},
  dispatch: () => {},
};

TextTools.propTypes = {
  lang: PropTypes.object,
  texts: PropTypes.object,
  bookProperties: PropTypes.object,
  dispatch: PropTypes.func,
};

export default connect(state => ({
  texts: state.entities.texts,
  editorUI: state.editorUI.canvas,
  bookProperties: state.bookProperties,
}))(TextTools);



// WEBPACK FOOTER //
// ./src/components/text-tools/TextTools.jsx